import { Longhand } from "../longhand.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-collapse}
 * @internal
 */
export default Longhand.fromKeywords({ inherits: true }, "separate", "collapse");
//# sourceMappingURL=border-collapse.js.map